import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unsvgo-map-shipcursor",
  "use": "icon-unsvgo-map-shipcursor-usage",
  "viewBox": "0 0 12 23",
  "content": "<symbol viewBox=\"0 0 12 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-unsvgo-map-shipcursor\">\n<path d=\"M0.958496 23L5.54183 6.5L11.0418 23H0.958496Z\" fill=\"currentColor\" />\n<path d=\"M5.54199 10.1667V1H9.20866\" stroke=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol